import { useCallback, useState } from 'react'

interface UseBankTransactionsSandboxResponse {
  isSandboxOpen: boolean
  closeSandbox: () => void
  openSandbox: () => void
}

/**
 * Open/closed state of the bank transactions demo sandbox. Each page that offers the demo owns its own instance
 * and renders `BankTransactionsSandbox` itself, so this hook stays free of any import into the transactions view.
 * Pass `getInitialIsOpen` to start with the sandbox open, e.g. when the user arrived from a "try the demo" action.
 */
export const useBankTransactionsSandbox = (getInitialIsOpen?: () => boolean): UseBankTransactionsSandboxResponse => {
  const [isSandboxOpen, setIsSandboxOpen] = useState(getInitialIsOpen ?? false)

  const openSandbox = useCallback(() => {
    setIsSandboxOpen(true)
  }, [])

  const closeSandbox = useCallback(() => {
    setIsSandboxOpen(false)
  }, [])

  return { isSandboxOpen, closeSandbox, openSandbox }
}
